module.exports = __webpack_public_path__ + "static/img/inbox_kitten.a4f79e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inbox_kitten.png
// module id = kt0Y
// module chunks = 1